import { useEffect, useState } from "react";
import { isAuthenticated } from "../../auth";
import { listProviderShopsForSeller } from "../services/providerProductService";

export const normalizeProviderEntry = (entry) => ({
  ...entry,
  provider: entry?.provider || {},
  shop: entry?.shop || {},
  products: Array.isArray(entry?.products) ? entry.products.filter((product) => product?._id) : [],
});

export default function useProvidersMatrix({ page, scope, search, sortBy, filters }) {
  const [providers, setProviders] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalProducts, setTotalProducts] = useState(null);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [version, setVersion] = useState(0);
  const filtersKey = JSON.stringify(filters || {});
  useEffect(() => {
    let current = true;
    setLoading(true);
    setError("");
    listProviderShopsForSeller(isAuthenticated()?.token, { page, limit: 12, scope, search, sortBy, filters }).then((result) => {
      if (!current) return;
      if (result?.error) setError(result.error);
      else {
        const entries = (Array.isArray(result?.providers) ? result.providers : []).filter((entry) => entry?.provider?._id).map(normalizeProviderEntry);
        setProviders(entries);
        setTotal(result?.totalProviders ?? result?.total ?? entries.length);
        setTotalProducts(result?.totalProducts ?? null);
        setHasMore(Boolean(result?.hasMore));
      }
      setLoading(false);
    });
    return () => { current = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- filtersKey is the stable serialization of `filters`
  }, [page, scope, search, sortBy, filtersKey, version]);
  return { providers, total, totalProducts, hasMore, loading, error, reload: () => setVersion((value) => value + 1) };
}
